/* LOLALAN · Zen Anchor: looping video that plays muted while it's on screen, with a pause button. */
(function () {
  'use strict';

  if (customElements.get('zen-video')) return;

  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  customElements.define(
    'zen-video',
    class ZenVideo extends HTMLElement {
      connectedCallback() {
        if (this._zenReady) return;
        this._zenReady = true;

        var video = (this.video = this.querySelector('video'));
        this.toggle = this.querySelector('[data-zen-video-toggle]');
        if (!video) return;

        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.removeAttribute('controls');

        // People who ask for reduced motion start with the poster and press play themselves.
        this.userPaused = reduceMotion();

        video.addEventListener('play', () => this.update());
        video.addEventListener('pause', () => this.update());

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            if (video.paused) {
              this.userPaused = false;
              this.play();
            } else {
              this.userPaused = true;
              video.pause();
            }
          });
        }

        this.update();

        if (!('IntersectionObserver' in window)) {
          if (!this.userPaused) this.play();
          return;
        }

        new IntersectionObserver(
          (entries) => {
            var inView = entries[0].isIntersecting;
            if (inView && !this.userPaused) {
              this.play();
            } else if (!inView && !video.paused) {
              video.pause();
            }
          },
          { threshold: 0.35 }
        ).observe(this);
      }

      play() {
        var promise = this.video.play();
        if (promise && promise.catch) {
          promise.catch(() => this.update());
        }
      }

      update() {
        if (!this.toggle) return;
        var playing = !this.video.paused;
        this.toggle.dataset.state = playing ? 'playing' : 'paused';
        this.toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
    }
  );
})();
